import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const SocialButton = ({icon, url}) => {
    return <a href={url} className="mr-3 p-3 py-2 mb-2 md:mb-0 text-gray-700 transition duration-300 ease-in-out hover:text-white hover:text-primary-light border-transparent border rounded-lg bg-gray-50 shadow-xl">
        <FontAwesomeIcon icon={icon} size="lg"/>
    </a>
}